import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00e9a57d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e9a57d')) {
      api.createRecord('00e9a57d', component.options)
    } else {
      api.reload('00e9a57d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00e9a57d&", function () {
      api.rerender('00e9a57d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/support/screens/SupportScreen/index.vue"
export default component.exports